import React from 'react';
import Card from '../../../components/card/Card';
import H from '../../../components/texts/h/H';
import { useClientTheme } from '../../../context/ThemeContext';

type AtlanticSectionHeaderProps = {
  title: string;
  testId?: string;
};

/**
 * Banner header used in Atlantic risk summary sections (e.g. Solicitud, Scores Nosis).
 */
const AtlanticSectionHeader: React.FC<AtlanticSectionHeaderProps> = ({
  title,
  testId,
}) => {
  const { clientTheme } = useClientTheme();

  const header = (
    <Card
      variant={clientTheme ? 'primary' : 'success'}
      modifier="weak"
      spacing="2"
    >
      <H
        type="4"
        variant="neutral-1"
        withMargin={false}
        weight="bold"
        modifier="strong"
      >
        {title}
      </H>
    </Card>
  );

  if (testId) {
    return <div data-testid={testId}>{header}</div>;
  }

  return header;
};

export default AtlanticSectionHeader;
